<template>
    <div
      class="payment-plans gantt-scroll"
      :style="{ width: width, height: '100vh' }"
    >
    <div class="container">
      <div class="closer">
        <icon-button
          :icon="{ name:'close-1', type:'bold' }"
          size="small"
          @onClick="close"
        />
      </div>
      <div class="title">
        <div class="title-h1">
          {{ locales('plans_popup_title') }}
        </div>
        <div>
          <inline-notification
            v-if="isTrial"
            type="info"
            :text="locales('pricing_page_trial_title_notification', { planName: 'Business'})"
          />
        </div>
      </div>
      <div class="body">
        <payment-plans-widget
          :plans="plans"
          :users-count-list="dropdownUsersSelection"
          :selected="selectedUsers"
          :is-annual="isAnnual"
          :is-popup="false"
          @toggleAnnual="toggleAnnual"
          @buyPlanClick="buyPlanClick"
          @upgradePlanClick="upgradePlanClick"
          @changeUserCount="changeUserCount"
          @onClickLearnMore="onClickLearnMore"
        />
        <div
          ref="studentsSection"
          class="students-container"
        >
          <div class="students">
            <div class="students__inner">
              <p class="students__title">
                {{ locales('plans_students_title') }}
              </p>
              <p
                class="students__desc"
                v-html="locales('plans_students_description')"
              />
              <div class="students__btn">
                <button
                  class="btn btn--transparent"
                  @click="studentsClick"
                >
                  {{ locales('learn_more') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          id="features"
          ref="features"
          class="features border-wrapper"
        >
          <div
            ref="table"
            class="table"
          >
            <div
              ref="tableHead"
              class="table-head"
            >
              <div
                ref="tableHeadTitle"
                class="table-head-title"
              >
                <div class="features-title title-h2">
                  {{ locales('pricing_plans_features_table_head') }}
                </div>
              </div>
              <div class="head-plans-wrapper">
                <div
                  v-for="(plan, index) in plans"
                  :key="index"
                  :class="['table-plan-cell head-cell', plan.name]"
                >
                  <div
                    v-if="plan.name !== 'enterprise'"
                    class="inner-info"
                  >
                    <!-- <div class="plan-name">
                      {{ locales(`${plan.name}_plan_locale`) }}
                    </div> -->
                    <div
                      class="plan-name"
                      :style="{textTransform: 'capitalize'}"
                    >
                      {{ plan.plan_name }}
                    </div>
                    <div class="price-desc">
                      {{ `$ ${plan.price}` }} USD
                    </div>
                  </div>
                  <div
                    v-else
                    class="inner-info"
                  >
                    <div class="plan-name">
                      {{ locales(`${plan.name}_plan_locale`) }}
                    </div>
                    <div class="price-desc">
                      {{ locales('pricing_custom_price_title') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              ref="tableBody"
              :class="`table-body ${isCollapsed ? 'collapsed' : ''}`"
            >
              <table-group
                v-for="(group, index) in featuresTable"
                ref="tableGroup"
                :key="index"
                :plans="plans"
                :group="group"
              />
            </div>
          </div>
          <div
            ref="tableCollapse"
            :class="`table-collapse ${isCollapsed ? 'collapsed' : ''}`"
            @click="collapseTable()"
          >
            <button>
              {{ `${isCollapsed ? locales('pricing_table_collapse_hide') : locales('pricing_table_collapse_show')}` }}
              <svgImage :name="'pricing-table-collapse-icon'" />
            </button>
          </div>
        </div>
        <div
          ref="faq"
          class="faq"
        >
          <div class="faq-title">
            {{ locales('faq_plans_locales') }}
          </div>
          <div class="faq-list">
            <div
              v-for="(item, index) in faqConfig"
              :key="index"
              class="faq-item"
              :data-key="item.key"
              @click="showAnswer"
            >
              <div class="question">
                {{ item.question }}
              </div>
              <div class="check-icon">
                <webix-ui :config="icons.checkIcon" />
              </div>
              <div
                class="answer"
                v-html="item.answer"
              />
            </div>
          </div>
        </div>
        <div
          ref="footer"
          class="contact-footer"
        >
          <div class="footer-title">
            {{ locales('plans_popup_footer_title') }}
          </div>
          <div
            class="contact-us"
            @click="chatClick"
            v-html="locales('footer_contact_link_locale')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InlineNotification from '$$vueCmp/nofitication/inline/InlineNotification.vue';
import plansModel from '../../models/plans';
import bubleSmallIcon from '../../svg/pricing/bubble_ic_small.svg';
import checkIcon from '../../svg/pricing/faq_arrow_down.svg';
import svgImage from '../common/VueComponents/VueIcon/vgpSvgImage.vue';
import IconButton from '../common/VueComponents/globalButton/withIcon/iconButton.vue';
import svgIconForVue from '../common/svgIconForVue';
import paymentPlansWidget from './components/paymentPlansWidget.vue';
import tableGroup from './components/tableGroup.vue';
import helpers from './helpers';

import Payment from './payment';

export default {
  components: {
    tableGroup,
    svgImage,
    IconButton,
    paymentPlansWidget,
    InlineNotification,
  },
  data() {
    return {
      Payment: null,
      locales: __,
      isAnnual: true,
      plans: [],
      featuresTable: [],
      dropdownUsersSelection: [],
      selectedUsers: null,
      faqConfig: [
        {
          question: __('question_locale_1'),
          answer: __('answer_locale_1'),
          key: 'free',
        },
        {
          question: __('question_locale_2'),
          answer: __('answer_locale_2'),
          key: 'payment options',
        },
        {
          question: __('question_locale_3'),
          answer: __('answer_locale_3'),
          key: 'discounts',
        },
        {
          question: __('question_locale_4'),
          answer: __('answer_locale_4'),
          key: 'data hosted',
        },
        {
          question: __('question_locale_5'),
          answer: __('answer_locale_5'),
          key: 'gdpr',
        },
        // {
        //   question: __('question_locale_6'),
        //   answer: __('answer_locale_6'),
        // },
        // {
        //   question: __('question_locale_7'),
        //   answer: __('answer_locale_7'),
        // },
      ],
      isActive: false,
      isCollapsed: false,
      icons: {
        checkIcon: svgIconForVue(checkIcon, 24, 24),
        bubleIcon: svgIconForVue(bubleSmallIcon, 21, 21),
      },
    };
  },
  computed: {
    leftSidebarWidth() {
      return this.$store.getters.leftSidebarWidth;
    },
    isShow() {
      return this.$store.getters['plansPopup/isShowPlans'];
    },
    width() {
      const width = `calc(100% - ${this.leftSidebarWidth}px)`;

      return width;
    },
    realUsersCount() {
      return this.$store.getters['resourcesModel/getAllRealResources'].length;
    },
    isTrial() {
      return plansModel.isTrial();
    },
  },
  watch: {
    $route(to, from) {
      this.$store.commit('paymentClient/showPaymentPage', false);
    },
    selectedUsers(selected) {
      this.plans = this.Payment.getPlansWithCurrentPriceByUserCount(selected.count, this.isAnnual);
    },
    leftSidebarWidth() {
      setTimeout(() => {
        this.onResize();
      }, 10);
    },
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener('resize', this.onResize);

    this.mainNode = this.$el;
    this.mainNode.addEventListener('scroll', this.onScroll);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);

    this.mainNode?.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    init() {
      this.Payment = new Payment();

      this.selectedUsers = this.Payment.getNextNumberOfUsersForPaymentPage();
      this.dropdownUsersSelection = this.Payment.usersSelection;
      this.featuresTable = helpers.getTableFeatures();
      // this.$store.commit('paymentClient/setNextCount', this.selectedUsers.count);

      userExtAnalytics.log('pricing_upgrade_account_clicked');
    },
    onResize() {
      const table = this.$refs.table;
      const tableHead = this.$refs.tableHead;

      tableHead.style.width = `${table.clientWidth}px`;
    },
    onScroll() {
      const table = this.$refs.table;
      const tableHead = this.$refs.tableHead;
      const tableCollapse = this.$refs.tableCollapse;

      if (table && tableHead && tableCollapse) {
        if (table.getBoundingClientRect().top < 0 && table.getBoundingClientRect().bottom - tableCollapse.clientHeight > 0) {
          tableHead.style.width = `${table.clientWidth}px`;
          tableHead.classList.add('fixed');
          tableHead.style.top = null;
        } else if (table.getBoundingClientRect().top > 0) {
          tableHead.classList.remove('fixed');
        } else if (table.getBoundingClientRect().bottom - tableCollapse.clientHeight < 0) {
          tableHead.style.top = `${table.getBoundingClientRect().bottom - tableCollapse.clientHeight}px`;
        }
      }
    },
    toggleAnnual(isAnnual) {
      this.isAnnual = isAnnual;

      const usersSelection = [...this.Payment.usersSelection];
      const fiveUsersItem = this.Payment.usersSelection.find(item => item.count === 5);
      const oneUsersItem = this.Payment.usersSelection.find(item => item.count === 1);
      const isSelectedOneUser = this.selectedUsers.count === 1;

      oneUsersItem.disabled = false;

      if (!isAnnual && this.realUsersCount >= 1) {
        if (isSelectedOneUser) {
          this.selectedUsers = fiveUsersItem;
          // this.$store.commit('paymentClient/setNextCount', this.selectedUsers.count);
        }
        oneUsersItem.disabled = true;
        usersSelection.splice(0, 1, oneUsersItem);
      } else if (isAnnual && this.realUsersCount > 1) {
        if (isSelectedOneUser) {
          this.selectedUsers = fiveUsersItem;
          // this.$store.commit('paymentClient/setNextCount', this.selectedUsers.count);
        }
        oneUsersItem.disabled = true;
        usersSelection.splice(0, 1, oneUsersItem);
      }

      this.dropdownUsersSelection = usersSelection;
      this.plans = this.Payment.getPlansWithCurrentPriceByUserCount(this.selectedUsers.count, this.isAnnual);

      userExtAnalytics.log('pricing_period_changed', { type: this.isAnnual ? 'annually' : 'monthly' });
    },
    changeUserCount(selected) {
      this.selectedUsers = selected;
    },
    close() {
      this.$store.commit('paymentClient/showPaymentPage', false);
    },
    removeHeight() {
      this.$el.querySelectorAll('.faq-item').forEach(item => {
        item.classList.remove('active');
        item.querySelector('.answer').style.position = 'absolute';
        item.querySelector('.answer').style.zIndex = '-1';
        item.querySelector('.answer').style.opacity = 0;
        item.querySelector('.answer').style.maxHeight = 0;

        item.querySelector('.check-icon').classList.remove('active');
      });
    },
    showAnswer(e) {
      const faqItem = e.target.closest('.faq-item');
      const answerNode = faqItem.querySelector('.answer');
      const checkIcon = faqItem.querySelector('.check-icon');
      const contentHeight = answerNode.scrollHeight;
      const dataKey = e.target.dataset.key;

      userExtAnalytics.log('pricing_faq_opened', dataKey);

      if (faqItem.classList.contains('active')) {
        checkIcon.classList.remove('active');
        this.removeHeight();

        return;
      }
      this.removeHeight();
      faqItem.classList.add('active');
      checkIcon.classList.add('active');
      answerNode.style.position = 'relative';
      answerNode.style.zIndex = '1';
      answerNode.style.opacity = '1';
      // answerNode.style.maxHeight = `${contentHeight + 20}px`;
      answerNode.style.maxHeight = `${contentHeight + 40}px`;
    },
    chatClick(e) {
      const target = e.target.closest('.contact-us');
      const contactLink = target.querySelectorAll('span');

      contactLink && this.$store.dispatch('footer/chatClickHandler');
    },
    studentsClick() {
      this.$store.commit('paymentClient/showStudentsPage', true);
    },
    collapseTable() {
      this.isCollapsed = !this.isCollapsed;
    },
    buyPlanClick(plan) {
      this.Payment.buyPlan(plan, this.selectedUsers.count, this.isAnnual);
    },
    upgradePlanClick(plan) {
      this.Payment.upgradePlan(plan, this.selectedUsers.count, this.isAnnual);
    },
    onClickLearnMore() {
      document.querySelector('#features').scrollIntoView({
        behavior: 'auto',
      });
    },
  },
};
</script>

<style scoped src="./less/paymentPlans.less"></style>
<style lang="less">
.closer {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 2px;

  &:hover {
    .webix_template {
      background-color: #eee;
      cursor: pointer;
    }
  }
}

.check-icon {
  .webix_template {
    cursor: pointer;
  }
}
.contact-us {
  span {
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
  }
}
</style>
